import { render, staticRenderFns } from "./CreateCollection.vue?vue&type=template&id=7460f958&scoped=true"
import script from "./CreateCollection.vue?vue&type=script&lang=js"
export * from "./CreateCollection.vue?vue&type=script&lang=js"
import style0 from "./CreateCollection.vue?vue&type=style&index=0&id=7460f958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7460f958",
  null
  
)

export default component.exports